// ============================================================================
// National Health Intelligence — population-health analytics API.
//
// Powers /superuser/national. Platform-admin only (gated server-side by
// IsAdminRole). Returns a single payload with independent sections; the
// feature module renders one tab per section. See backend
// organizations/national_intelligence.py for the response shape.
// ============================================================================
import { api } from './client.js'
import { endpoints } from './endpoints.js'

/**
 * Fetch the full national intelligence payload.
 * @param {object} opts
 * @param {number} opts.days  activity window (1..365); scopes the
 *   activity-driven sections. Prevalence/risk are lifetime; trends span
 *   the last 12 months regardless.
 */
export async function getNationalIntelligence({ days = 30 } = {}) {
  const { data } = await api.get(endpoints.nationalIntelligence, {
    params: { days },
  })
  return data
}
